import { apiV2, errorHandler } from "./index";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import { API_ERROR, FETCH_ALL_ONBOARDING_DATA } from "../constants/ActionTypes";

//= ===============================
// Client actions
//= ===============================

export function fetchOnboardingData() {
  return function (dispatch) {
    apiV2.get('/onboarding')
      .then(response => {
        dispatch({
          type: FETCH_ALL_ONBOARDING_DATA,
          payload: response.data
        });
      })
      .catch(error => {
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}

export function updateOnboardingData(onboarding_data_json) {
  return function (dispatch) {
    return apiV2.put('/onboarding', onboarding_data_json)
      .then(response => {
      })
      .catch(error => {
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}
